import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import SocialSharing from '../shared/SocialSharing';
import SafePureComponent from '../shared/SafePureComponent';
import { MP_ClICKED_NAVBAR } from '../../utils/mixPanelEvents';
import { GIG_NAV_MENU } from '../../utils/events';
import UGCTranslateButton from '../UGCTranslateButton';
import AddToFavorite from './AddToFavorite';
import EditGig from './EditGig';
import ReportBtn from './ReportGig/ReportBtn';

import './style.scss';

class TopNav extends Component {

    constructor() {
        super();

        this.onNavClick = this.onNavClick.bind(this);
    }

    onNavClick(e, section) {
        const { biEvents } = this.context;

        e.preventDefault();
        this.props.scrollToSection(section);

        const mixPanelParams = {
            clickedSection: e.target.text,
            displayedSections: this.getValidatedSections().map(({ sectionKey }) => sectionKey)
        };
        biEvents.sendMixPanelEvent({ eventName: MP_ClICKED_NAVBAR, params: mixPanelParams });
    }

    getValidatedSections() {
        const { pageSectionsList } = this.props;

        return pageSectionsList.filter((section) => section.validated);
    }

    render() {
        if (!this.props.topNav) {
            return null;
        }

        const {
            collections,
            isLoggedIn,
            isPageOwner,
            topNav,
            selSection,
            updateCollections,
            isTrustedUser,
            showUGCTranslateBtn = false
        } = this.props;

        const { requestContext, general } = this.context;
        const { params, current_user } = requestContext;
        const { gigId } = general;
        const currentUser = isLoggedIn ? current_user : {};

        return (
            <div className="top-nav">
                <nav className="max-width-container">
                    <ul>
                        {
                            this.getValidatedSections().map((section, index) => {
                                const { sectionKey } = section;

                                return (
                                    <li key={index}
                                        className={classNames(`nav-${sectionKey}`, { 'selected': selSection === sectionKey })}>
                                        <a href={`#${sectionKey}`} onClick={(e) => this.onNavClick(e, section)}>
                                            <I18n k={`gig_page_perseus.top_nav.page_sections.${sectionKey}`}/>
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    <aside className="actions">
                        {showUGCTranslateBtn &&
                        <UGCTranslateButton componentName={GIG_NAV_MENU}
                            gigId={gigId}
                            user={currentUser}
                            isLeanStyle={true}/>}

                        {isPageOwner &&
                        <EditGig {...params}/>}

                        {!isPageOwner &&
                        <AddToFavorite collections={collections}
                            gigId={topNav.gigId}
                            gigCollectedCount={topNav.gigCollectedCount}
                            currentUser={currentUser}
                            sellerId={topNav.sellerId}
                            updateCollections={updateCollections}/>}

                        {isLoggedIn && !isPageOwner &&
                        <ReportBtn isTrustedUser={isTrustedUser}/>}

                        {!isPageOwner &&
                        <SocialSharing gigId={topNav.gigId}
                            gigTitle={topNav.gigTitle}
                            sellerName={topNav.sellerName}
                            isPageOwner={isPageOwner}
                            title={<I18n k="gig_page_perseus.general.share"/>}/>}
                    </aside>
                </nav>
            </div>
        );
    }
}

TopNav.propTypes = {
    topNav: PropTypes.shape({
        gigId: PropTypes.number,
        gigTitle: PropTypes.string,
        gigCollectedCount: PropTypes.number,
        sellerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        sellerName: PropTypes.string
    }).isRequired,
    collections: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    isPageOwner: PropTypes.bool,
    selSection: PropTypes.string,
    updateCollections: PropTypes.func,
    pageSectionsList: PropTypes.array,
    isTrustedUser: PropTypes.bool,
    showUGCTranslateBtn: PropTypes.bool
};

TopNav.contextTypes = {
    biEvents: PropTypes.object,
    requestContext: PropTypes.object,
    general: PropTypes.object
};

export { TopNav };
export default SafePureComponent(TopNav);
